<template>
  <div>
    <IstIcon
      :data-test-id="'icon-alias-' + person?.fornavn"
      :size="size"
      class="eye-icon"
      name="mdi-eye-off-outline" />
    <q-tooltip class="alias-tool-tip">
      <div>{{ $t('denne-person-har-navne-adresse-beskyttelse') }}</div>
      <div v-if="person">
        {{
          $t('alias-fullname-rigtigt-navn-realname', [
            `${person.fornavn} ${person.efternavn}`,
            person.realName,
          ])
        }}
      </div>
    </q-tooltip>
  </div>
</template>

<script setup lang="ts">
  import { MedarbejderWithProtectStatus } from '@/handlers/medarbejderHandlers';

  interface Props {
    person?: MedarbejderWithProtectStatus;
    size?: 'sm' | 'md' | 'lg';
  }

  const { person, size = 'md' } = defineProps<Props>();
</script>

<style scoped lang="scss">
  .eye-icon {
    color: $ist-color-red;
  }
</style>
